import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

import { TextButton } from '@/shared/components/ui/button/text-button/text-button';
import { TResetFiltersButtonProps } from '@/shared/components/ui/data-table/components/reset-filters-button/reset-filters-button.types';
import { useFilterDefaults } from '@/shared/components/ui/data-table/hooks/use-filter-params/filter-defaults-context';
import { usePaginationQueryParams } from '@/shared/components/ui/pagination/hooks/use-pagination-query-params/use-pagination-query-params';

export const ResetFiltersButton = ({
  disabled = false,
}: TResetFiltersButtonProps) => {
  const { t } = useTranslation();
  const { resetFilters } = usePaginationQueryParams();
  const filterDefaults = useFilterDefaults();
  const [searchParams] = useSearchParams();

  if (disabled || filterDefaults?.isAtDefaults(searchParams)) return null;

  return (
    <TextButton onClick={() => resetFilters(filterDefaults?.getDefaults())}>
      {t('ui:reset_filters')}
    </TextButton>
  );
};
